import type { App } from 'vue';
import _ from 'lodash';

export default {
    install(app: App) {
        // Make Lodash globally available
        app.config.globalProperties.$_ = _;
    },
};
